// extracted by mini-css-extract-plugin
export var loader = "loader-modules--loader--36bds";
export var load8 = "loader-modules--load8--3cmE4";